import { useRoutes } from "react-router-dom";

function Routes(props) {
  return useRoutes(props.entryRoutes);
}

export default Routes;
